import { usePipedriveStore } from "..";
import { showErrorToast } from "../components/ToastContainer";
import useCurrentOrFallbackPipedriveUserId from "./useCurrentOrFallbackPipedriveUserId";

const useDealNoteCreate = (): (dealId: number, text: string) => Promise<void> => {
    const pipedriveStore = usePipedriveStore();
    const pipedriveUserId = useCurrentOrFallbackPipedriveUserId();

    return async (dealId: number, text: string): Promise<void> => {
        try {
            await pipedriveStore.createDealNote(dealId, text, pipedriveUserId);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useDealNoteCreate;